import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import ImageScrubber from '../ImageScrubber'
import { withTranslation, Trans } from 'react-i18next'
import { interiorView01ImageOptions } from './views/InteriorView01'
import { interiorView04ImageOptions } from './views/InteriorView04'
import { interiorView06ImageOptions } from './views/InteriorView06'

class Xr41Saloon extends Component {
  constructor (props) {
    super(props)
    this.handleLayoutChange = this.handleLayoutChange.bind(this)
  }

  handleLayoutChange (newValue) {
    let configuration = this.props.configuration
    configuration.Layout = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    const image = (
      <ImageScrubber
        images={[
          <ConfiguratorImage
            key='view01'
            boat='Xr41'
            configuration={this.props.configuration}
            options={interiorView01ImageOptions}
          />,
          <ConfiguratorImage
            key='view04'
            boat='Xr41'
            configuration={this.props.configuration}
            options={interiorView04ImageOptions}
          />,
          <ConfiguratorImage
            key='view06'
            boat='Xr41'
            configuration={this.props.configuration}
            options={interiorView06ImageOptions}
          />
        ]}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Saloon' />
          </h1>

          <p>
            <Trans defaults='The interior of the XR 41 is thoughtfully designed to combine comfort, style, and practicality, making life onboard as enjoyable as it is effortless.' />
          </p>
          <p>
            <Trans defaults='We offer three different layout options for the interior of the XR 41.' />
          </p>
          
          <p>
            <Trans defaults='The interior is designed in modules and therefore very flexible and can accommodate various lifestyles.' />
          </p>

          <RadioGroup
            label={this.props.t('Layout options:')}
            options={this.props.LayoutOptions}
            value={this.props.configuration.Layout}
            onChange={this.handleLayoutChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41Saloon)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41Saloon.js